module.exports = __webpack_public_path__ + "4f73c68cc0acfdded7a9add90a1e8fb7.pdf";